const CustomLoader = () => {
    return <div className="custom-loader m-auto"></div>
}
export default CustomLoader